export default __webpack_public_path__ + "images/10f330b416e853ff834e8cb83428d988-shipping-truck.svg";